import { FormEvent } from 'react';
import { FormControl } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SelectField from 'components/forms/selectField/SelectField';
import { BOOKING_TYPES } from 'models/BookingType';
import PropertyFormFieldLabel from '../../../common/PropertyFormFieldLabel';
import { airbnbSettingsGuestRequirementsDefaultValues } from '../../PropertySettingsMainTab.schema';
import usePropertySettingsInitData from '../../../usePropertySettingsInitData';
import { checkGuestRequirementsFieldVisibility } from './AirbnbSettings.utils';

const BookingTypeField = () => {
  const { setValue } = useFormContext();
  const { property } = usePropertySettingsInitData();
  const { t } = useTranslation();

  const bookingTypeOptions = [
    BOOKING_TYPES.BOOKING_REQUEST,
    BOOKING_TYPES.INSTANT_BOOKING,
  ].map((value) => ({
    label: t(`common.bookingType.${value}`),
    value,
  }));

  const isGuestRequirementsFieldVisible =
    checkGuestRequirementsFieldVisibility(property);

  const onChange = isGuestRequirementsFieldVisible
    ? (event: FormEvent<FormControl>) => {
        const bookingType = (event.target as HTMLSelectElement).value;
        const guestRequirementsDefaultValue =
          airbnbSettingsGuestRequirementsDefaultValues[bookingType];

        setValue(
          'airbnbSettings.guestRequirements',
          guestRequirementsDefaultValue,
          { shouldDirty: true },
        );
      }
    : undefined;
  return (
    <SelectField
      label={
        <PropertyFormFieldLabel name="airbnbSettings.bookingType">
          {t('pageProperty.mainSettings.airbnbSettings.bookingType')}
        </PropertyFormFieldLabel>
      }
      name="airbnbSettings.bookingType"
      options={bookingTypeOptions}
      onChangeHandler={onChange}
      colSmInput={7}
      colSmLabel={5}
      required
    />
  );
};

export default BookingTypeField;
